import { SegmentsFolderId, SegmentsFoldersSegmentsFragment } from 'common/src/generated/types';
import { isNonEmptyArray } from 'common/src/util/array';
import { isNonEmptyString } from 'common/src/util/string';
import { SegmentFragment } from 'common/src/vo/segment';
import * as React from 'react';
import { Button } from '../../designSystem/components/button';
import { Modal } from '../../designSystem/components/modal/modal';
import { RichSelect } from '../../designSystem/components/richSelect/richSelect';
import { Textarea } from '../../designSystem/components/textarea';
import { TextInput } from '../../designSystem/components/textInput';
import { useSegmentUpdateMetadataMutation } from '../../generated/graphqlHooks';
import { useHeavent } from '../../hooks/useHeavent';
import { useSegmentsContext } from '../segmentsContext';

interface ISaveSegmentProps {
    onClose: () => void;
    segment: SegmentFragment;
    segmentsFolders: SegmentsFoldersSegmentsFragment[];
}

export const UpdateSegmentMetadataModal = (props: ISaveSegmentProps) => {
    const { eventId, organizationId, reload } = useSegmentsContext();
    const { translate } = useHeavent();
    const { mutate, isLoading } = useSegmentUpdateMetadataMutation();
    const [name, setName] = React.useState(props.segment.name);
    const [segmentFolderId, setSegmentFolderId] = React.useState(props.segment.segmentFolderId);
    const [description, setDescription] = React.useState(props.segment.description || undefined);
    const valid = isNonEmptyString(name);

    return (
        <Modal.Root isOpen={true} onClose={props.onClose}>
            <Modal.Portal>
                <Modal.Header icon="gear" subtitle={translate('mettez_jour_l_55467')}>
                    {translate('mise_jour_de_80873')}
                </Modal.Header>

                <Modal.Content gap="4">
                    <TextInput
                        label={translate('nom_de_la_vue_66415')}
                        value={name}
                        onChange={setName}
                    />

                    <RichSelect
                        isSearchVisible={true}
                        label={translate('dossier_00726')}
                        shouldParseAsInt={true}
                        values={[segmentFolderId]}
                        onChange={(newSegmentFolderId) => {
                            if (isNonEmptyArray(newSegmentFolderId)) {
                                setSegmentFolderId(newSegmentFolderId[0] as SegmentsFolderId);
                            }
                        }}
                    >
                        {props.segmentsFolders.map((segmentFolder) => (
                            <option key={segmentFolder.id} value={segmentFolder.id}>
                                {segmentFolder.name}
                            </option>
                        ))}
                    </RichSelect>

                    <Textarea
                        label={translate('Description')}
                        value={description}
                        onChange={setDescription}
                    />
                </Modal.Content>

                <Modal.Buttons>
                    {() => (
                        <Button
                            disabled={!valid}
                            isLoading={isLoading}
                            onClick={async () => {
                                await mutate({
                                    organizationId,
                                    eventId,
                                    description,
                                    name,
                                    segmentFolderId,
                                    segmentId: props.segment.id
                                });

                                reload();
                            }}
                        >
                            {translate('mettre_jour_85141')}
                        </Button>
                    )}
                </Modal.Buttons>
            </Modal.Portal>
        </Modal.Root>
    );
};
